/**
 * @note Se utiliza moment para formatear la hora que viene desde el servicio y solucionar un issue que el
 * componente <datepicker/> al rederizar no le reste un dia al momento de presentar en el formulario
 */
import moment from "moment";

export default class Alarm {
	constructor({
		company_id,
		created_at,
		days,
		emails,
		end_date,
		end_hour,
		init_date,
		init_hour,
		key,
		name,
		resources_id,
	}) {
		this.company_id = company_id || 0;
		this.created_at = created_at || "";
		this.days = days || [];
		this.emails = emails || [];
		this.end_date = end_date !== undefined ? moment(end_date).format() : new Date();
		this.end_hour = end_hour || "";
		this.init_date = init_date !== undefined ? moment(init_date).format() : new Date();
		this.init_hour = init_hour || "";
		this.key = key || "";
		this.name = name || "";
		this.resources_id = resources_id || [];
	}

	updateResourcesId(resources) {
		this.resources_id = resources.map((resource) => resource.id);
	}
}
